var path = '/templates/projects.campaigns/views/directives/campaign_recent_segment_table.html';
var html = "<table class=\"table table-bordered table-striped table-condensed\"><tr><td>{{ 'projectsCampaignsViews.directives.campaignRecentSegmentTable.houmon_kazu' | translate }}</td><td>{{segment.session_count || 0}}</td></tr><tr><td>{{ 'projectsCampaignsViews.directives.campaignRecentSegmentTable.konbaajon_kazu' | translate }}</td><td>{{segment.conversion_count || 0}}</td></tr></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.campaigns/views/directives/campaign_recent_segment_table.html
// module id = 1381
// module chunks = 0